var map = {
	"./brownclassroom/index.js": 2797,
	"./castle/index.js": 2800,
	"./city/index.js": 2803,
	"./club/index.js": 2806,
	"./greenLounge/index.js": 2809,
	"./gym/index.js": 2812,
	"./quest/index.js": 2815,
	"./sahara/index.js": 2818,
	"./sciencelab/index.js": 2821,
	"./sciencequest/index.js": 2824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2796;